export type GroupInput = {
    avatar: string;
    buttonType: "panel" | "float";
    groupType: "private" | "public" | "celebrity";
    id: string;
    showAvatar: boolean;
    title: string;
    usersCount: string;
    wrapperParams: WrapperParams;
};

export enum WRAPPER_ACTIONS_ENUM {
    OPEN_POST_DETAILS = "opd",
    OPEN_POST_LIST = "opl",
    OPEN_POST_COMMENT = "opc",
}

export type WrapperParams = {
    postId?: string;
    commentId?: string;
    action?: WRAPPER_ACTIONS_ENUM;
};
